import { createTheme } from "@mui/material/styles";
import { colors } from "./colors";
import { px2Rem } from "../utils/functions";
import BiNeo from "../fonts/BiNeoIndustrial-Regular.ttf";
import OpenSans from "../fonts/OpenSans-Regular.ttf";

export const mainTheme = createTheme({
  palette: {
    primary: {
      main: colors.primary,
      contrastText: "#fff",
    },
    secondary: {
      main: colors.secondary,
      contrastText: "#fff",
    },
    warning: {
      main: colors.yellow.main,
      contrastText: colors.primary,
    },
    error: {
      main: colors.red.main,
    },
    action: {
      active: colors.gray.main,
      hover: colors.gray.main,
      focus: colors.gray.main,
      selected: colors.gray.main,
    },
    success: {
      main: colors.green.main,
    },
  },
  typography: {
    htmlFontSize: 16,
    fontFamily: ["OpenSans", "BiNeo"].join(","),
    body1: {
      color: colors.gray.text2,
      fontFamily: "OpenSans",
    },
    h2: {
      color: colors.primary,
      fontSize: px2Rem(40),
      fontFamily: "BiNeo",
      fontWeight: "bold",
    },
    h3: {
      color: colors.primary,
      fontSize: px2Rem(28),
      fontFamily: "BiNeo",
      fontWeight: "bold",
      "@media screen and (max-width: 450px)": {
        fontSize: "1rem",
      },
    },
    h4: {
      color: colors.primary,
      fontSize: px2Rem(24),
      fontFamily: "BiNeo",
      fontWeight: "bold",
      marginTop: "1rem",
      marginBottom: "1rem",
    },
    h5: {
      color: colors.gray.text,
      fontSize: px2Rem(24),
      fontFamily: "OpenSans",
      fontWeight: "normal",
      marginTop: "1rem",
      marginBottom: "1rem",
      "@media screen and (max-width: 450px)": {
        fontSize: "1rem",
      },
    },
    h6: {
      color: colors.gray.text,
      fontSize: px2Rem(16),
      fontFamily: "OpenSans",
      fontWeight: "normal",
      marginTop: "1rem",
      marginBottom: "1rem",
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: [
          {
            "@font-face": {
              fontFamily: "BiNeo",
              src: `url(${BiNeo}) format('truetype')`,
            },
          },
          {
            "@font-face": {
              fontFamily: "OpenSans",
              src: `url(${OpenSans}) format('truetype')`,
            },
          },
        ],
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          height: "49px",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          height: "49px",
          paddingRight: "5px !important",
          borderRadius: "12px !important",
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          padding: "0px 5px 0px 14px !important",
        },
        paper: {
          marginTop: "-5px",
          borderRadius: "0 0 25px 25px",
        },
        listbox: {
          marginTop: "5px",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          padding: "0px 5px 0px 14px!important",
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: colors.secondary,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: colors.gray.light,
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: "OpenSans",
          "&::hover": {
            cursor: "pointer",
          },
        },
      },
    },
    MuiSlider: {
      styleOverrides: {
        rail: {
          color: colors.gray.light2,
          width: "101%",
        },
        root: {
          height: "8px",
        },
        mark: {
          color: colors.primary,
          height: "3px",
          width: "3px",
        },
      },
    },
  },
});
